<template>
  <div class="user-avatar-dropdown">
    <Dropdown @on-click="handleClick">
      <Badge :dot="!!messageUnreadCount">
        <Avatar :src="user && user.avatar ? user.avatar : avatar"/>
      </Badge>
      <span style="vertical-align:middle;font-size:14px;">{{user ? user.userName : ''}}</span>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <!-- <DropdownItem name="message">
          消息中心<Badge style="margin-left: 10px" :count="messageUnreadCount"></Badge>
        </DropdownItem> -->
        <DropdownItem name="modifyPassword">修改密码</DropdownItem>
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <div class="modal-container" style="cursor:default;">
      <el-dialog  width="600px" :visible.sync="modifyPasswordVisible" title="修改密码">
        <modify-password/>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import './user.less'
import avatar from './avatar.png'
import { mapGetters } from 'vuex'
import ModifyPassword from './modify-password.vue'
export default {
  name: 'User',
  props: {
    userAvatar: {
      type: String,
      default: ''
    },
    messageUnreadCount: {
      type: Number,
      default: 0
    }
  },
  components: {
    ModifyPassword
  },
  data () {
    return {
      avatar,
      modifyPasswordVisible: false
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    logout () {
      this.$store.dispatch('logout', {router: this.$router})
    },
    modifyPassword () {
      this.modifyPasswordVisible = true
    },
    handleClick (name) {
      switch (name) {
        case 'logout': this.logout()
          break
        case 'modifyPassword': this.modifyPassword()
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/main/components/user/user.vue